import { AgreementInstallmentStatus } from "../../../shared/services/api/sinister/SinisterAgreementService";

export const INSTALLMENT_STATUS_OPTIONS: { value: AgreementInstallmentStatus; label: string }[] = [
	{ value: "paid", label: "Pago" },
	{ value: "pending", label: "Pendente" },
	{ value: "overdue", label: "Atrasado" },
	{ value: "canceled", label: "Cancelado" },
];

// Normaliza pra minúsculo antes de comparar — mesmo padrão de bug já visto/corrigido em
// negotiationStatusOptions.ts/agreementStatusOptions.ts (backend às vezes manda o valor com case
// diferente, o que fazia o chip cair no fallback e mostrar o valor cru).
const normalize = (status: string): string => (status ?? "").toLowerCase();

export const getInstallmentStatusLabel = (status: AgreementInstallmentStatus | string): string =>
	INSTALLMENT_STATUS_OPTIONS.find((option) => option.value === normalize(status))?.label ?? status;

// Mesma paleta pastel usada em StatusInstallmentChip (src/shared/components/StatusInstallmentChip.tsx).
export const getInstallmentStatusChipColors = (status: AgreementInstallmentStatus | string): { bg: string; color: string } => {
	switch (normalize(status)) {
		case "paid":
			return { bg: "#f0fdf4", color: "#2e7d32" };
		case "pending":
			return { bg: "#fffbe6", color: "#ed6c02" };
		case "overdue":
			return { bg: "#fef2f2", color: "#d32f2f" };
		case "canceled":
			return { bg: "#ECECEC", color: "#757575" };
		default:
			return { bg: "#ECECEC", color: "#757575" };
	}
};
